import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from '@/locales/ar/translation.json';
import en from '@/locales/en/translation.json';

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, ar: { translation: ar } },
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'ar'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
